import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
    Header,
    Footer,
} from '@usb-onboarding/product-recommender-components';
import {
    getAEMContent,
    initiateQuestionnaire,
} from '../../redux/actions';
import Loader from '../../atoms/Loader';
import Landing from '../../molecules/Landing';
import {
    productConfiguration,
    tealiumConfiguration,
} from '../../config';
import { productID } from '../../constants';
import {
    getGeneralReportingData,
    dispatchReportingEvent,
    tealiumUpdatedPageView,
    checkAndSetCorrelationId,
} from '../../utils';

const { aemUrl } = window.__conf__;

function LandingPage() {
    const [sitecatLoaded, setSitecatLoaded] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();

    const sessionID = useSelector(
        (state) => state.questionnaireReducer.sessionID,
    );
    const questionID = useSelector(
        (state) => state.questionnaireReducer.questionnaire?.id,
    );
    const AEMContent = useSelector(
        (state) => state.AEMContentReducer.AEMContent,
    );
    const AEMContentLoaded = useSelector(
        (state) => state.AEMContentReducer.loaded,
    );
    const error = useSelector((state) => state.errorReducer.error);
    const isLoading = useSelector(
        (state) => state.loaderReducer.isLoading,
    );

    const setSitecat = () => {
        setSitecatLoaded(true);
    };

    useEffect(() => {
        if (!window.utag) {
            document
                .getElementsByTagName('html')[0]
                .addEventListener('sitecat:loaded', setSitecat);
        } else {
            setSitecat();
        }
        dispatch(getAEMContent(productID));
        return () => {
            window.removeEventListener('sitecat:loaded', setSitecat);
        };
    }, []);

    useEffect(() => {
        if (AEMContentLoaded && sitecatLoaded) {
            const tealiumConfig = tealiumConfiguration[productID];
            const { siteSection, subSiteSection } = tealiumConfig;

            const currentPage =
                AEMContent.landingPage.title?.toLowerCase();

            const reportingData = getGeneralReportingData(
                currentPage,
                siteSection,
                subSiteSection,
            );

            dispatchReportingEvent(reportingData);
            tealiumUpdatedPageView();

            window.scrollTo(0, 0);
        }
    }, [sitecatLoaded, AEMContentLoaded]);

    useEffect(() => {
        if (error) {
            history.push('/tech-trouble');
        }
    }, [error]);

    useEffect(() => {
        if (sessionID) {
            history.push(`/questionnaire/${questionID}`);
        }
    }, [sessionID]);

    function startQuestionnaire() {
        checkAndSetCorrelationId();
        dispatch(
            initiateQuestionnaire(productConfiguration[productID]),
        );
    }

    function goBack() {
        window.location.href = AEMContent.backButtonLink;
    }

    return (
        <>
            {isLoading && <Loader />}
            <Header title={AEMContent.header.fullName} />
            <Helmet>
                <title> Start product recommender | U.S. Bank </title>
            </Helmet>
            <main id="app__content">
                <Landing
                    title={AEMContent.landingPage.title}
                    content={AEMContent.landingPage.content}
                    imageUrl={`${aemUrl}${AEMContent.landingPage.imageUrl}`}
                    handleNextClick={startQuestionnaire}
                    goBack={goBack}
                />
            </main>
            <Footer
                header={AEMContent.footer.connectionTitle}
                content={AEMContent.footer.footerDisclosure}
                privacyLabel={AEMContent.footer.privacyLabel}
                privacyUrl={AEMContent.footer.privacyUrl}
                fdic={AEMContent.footer.connectionContent}
                cobrowseLabel={AEMContent.footer.cobrowseLabel}
                cobrowseUrl={AEMContent.footer.cobrowseUrl}
            />
        </>
    );
}

export default LandingPage;
